@if (userId == authorKey && isDeleted == false) {
  <div class="position-relative w-100 comment row p-0 m-0">
    <div class="col-auto">
      <img src="{{userImageURL}}" height="27">
    </div>
    <div class="position-relative col m-0 p-0">
      <div class="position-absolute top-0 end-0">
        @if (isDeleted == false) {
          <button type="button" class="btn btn-outline-secondary btn-sm noborder" (click)="addCommentToComment()" >
            <i class="bi bi-chat-square-dots"></i>
          </button>
          <button type="button" class="btn btn-outline-secondary btn-sm noborder" (click)="removeComment()" >
            <i class="bi bi-trash3"></i>
          </button>
        }
      </div>
      @if (commentKey != service.editedCommentKey) {
        <span>
          <span  class="comment-date" (click)="editComment(commentKey)">
            {{authorName}}
            {{formattedDate}}
          </span>
          <span (click)="editComment(commentKey)">
            <div [innerHTML]="commentContent" class="content">
            </div>
          </span>
        </span>
      }
      @if (commentKey == service.editedCommentKey && isDeleted == false) {
        <span>
          <app-addcomment [organizationKey]="organizationKey" [contentKey]="commentKey" [projectKey]="projectKey" [channelKey]="channelKey" [userDisplayName]="userDisplayName" [newComment]="false" [userId]="userId" [commentKey]="commentKey" [commentContent]="commentContent" [pathSegments]="pathSegments" [userDisplayName]="userDisplayName" [contentType]="contentType" [userImageURL]="userImageURL" [projectName]="projectName" [embeddingModel]="embeddingModel"></app-addcomment>
        </span>
      }
      @if (commentKey != service.editedCommentKey) {
        <app-attachedfiles [organizationKey]="organizationKey" [contentKey]="commentKey" [canDelete]="true" [smallSplash]="true"></app-attachedfiles>
      }
      @for (comment of comments; track comment) {
        <div class="m-0">
          <app-showcomment [organizationKey]="organizationKey" [projectKey]="projectKey" [userId]="userId" [userDisplayName]="userDisplayName" [authorKey]="comment.userId" [authorName]="comment.userName" [channelName]="channelName" [channelPath]="channelPath" [channelKey]="channelKey" [dateOfCreation]="comment.dateOfCreation" [dateOfUpdate]="comment.dateOfUpdate" [isDeleted]="comment.isDeleted" [imageURLs]="comment.imageURLS" [formattedDate]="comment.formattedDate" [commentContent]="comment.content" [commentKey]="comment.key" [pathSegments]="newPathSegments" [userDisplayName]="userDisplayName" [contentType]="contentType" [userImageURL]="userImageURL" [projectName]="projectName" [embeddingModel]="embeddingModel">
          </app-showcomment>
        </div>
      }
    </div>
  </div>
}

@if (userId != authorKey && isDeleted == false) {
  <div >
    <div class="comment-wrapper">
      <span (click)="editComment(commentKey)" class="comment-date">
        {{authorName}}
        {{formattedDate}}
      </span>
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="addCommentToComment()" matTooltip="Add comment">
        <i class="bi bi-chat-square-dots"></i>
      </button>
      <div [innerHTML]="commentContent" class="content">
      </div>
      <app-attachedfiles [organizationKey]="organizationKey" [contentKey]="commentKey" [canDelete]="false"></app-attachedfiles>
    </div>
    @for (comment of comments; track comment) {
      <div class="m-0">
        <app-showcomment [organizationKey]="organizationKey" [projectKey]="projectKey" [userId]="userId" [userDisplayName]="userDisplayName" [authorKey]="comment.userId" [authorName]="comment.userName" [channelName]="channelName" [channelPath]="channelPath" [channelKey]="channelKey" [dateOfCreation]="comment.dateOfCreation" [dateOfUpdate]="comment.dateOfUpdate" [isDeleted]="comment.isDeleted" [imageURLs]="comment.imageURLS" [formattedDate]="comment.formattedDate" [commentContent]="comment.content" [commentKey]="comment.key" [pathSegments]="newPathSegments" [userDisplayName]="userDisplayName" [contentType]="contentType" [userImageURL]="userImageURL" [projectName]="projectName" [embeddingModel]="embeddingModel">
        </app-showcomment>
      </div>
    }
  </div>
}

@if (isDeleted == true) {
  <div >
    <div class="comment-removed">
      <span (click)="editComment(commentKey)" class="comment-date">
        {{authorName}}
        {{formattedDate}}
      </span>
      <div [innerHTML]="commentContent" class="content-removed">
      </div>
    </div>
  </div>
}
